import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Translation } from '@jsverse/transloco';
import { type TranslocoLoader, type TranslocoLoaderData } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly httpClient = inject(HttpClient);

  /**
   * Fetches a translation file from a specified path and returns an observable containing the translation data.
   *
   * @param {string} path - The file path or identifier for determining the translation to load.
   * @param {TranslocoLoaderData} [data] - Optional metadata for handling scoped translations or additional path details.
   * @return {Observable<Translation>} An observable that emits the fetched translation object.
   */
  getTranslation(path: string, data?: TranslocoLoaderData): Observable<Translation> {
    const language = data?.scope ? path.split('/').at(-1) ?? path : path;
    const assetPath = data?.scope
      ? `/i18n/${language}/${data.scope}.json`
      : `/i18n/${language}.json`;

    return this.httpClient.get<Translation>(assetPath);
  }
}
